<template>
  <div class="app-container">
    <div class="forget-password-container">
      <pang-title :text="$router.lang.get('會員  中心')" eng="Account"/>
      <div class="tab-container">
        <pang-tab
        :tabs="tabs" v-model:current="currentTab"/>
        <div class="tab2-container">
          <pang-tab
          :tabs="tabs2" v-model:current="currentTab2"/>
        </div>
        <template v-if="!passwordReseting && !emailSending">
          <div class="password-container">
            <div class="input-label">{{ $router.lang.get('賬號：') }}</div>
            <div class="email-input">
              <pang-input
              ref="username"
              :placeholder="$router.lang.get('請輸入賬號')"
              :validate="usernameValidator"
              :name="username"
              v-model:value="username"/>
            </div>
          </div>
          <div class="password-container">
            <div class="input-label">{{ $router.lang.get(currentTab2 == 0?'手機：':'信箱：')}}</div>
            <div class="input-container">
              <div class="sms-container"
                  v-if="currentTab2 == 0">
                  <pang-sms-input
                    :buttMsgField="currentTab2 == 0?'buttMsg3':'emailButtMsg3'"
                    :buttMsgCountingField="currentTab2 == 0?'buttMsgCounting3':'emailButtMsgCounting3'"
                    ref="sms"
                    :hint="currentTab2 == 0?$router.lang.get('请输入手机号，不为 0 开头的'):''"
                    v-model:areacode="areacode"
                    v-model:phone="phone"
                    v-model:code="code"
                    :validate="phoneValidator"
                    :verifyType="4"
                    :smsDisabled="!currentUser || phone.replace(/^0/, '') != currentUser.phone || areacode != currentUser.areacode"
                    @enter="submit()"
                  />
              </div>
              <div v-else class="email-input">
                <pang-input
                ref="email"
                :placeholder="$router.lang.get('請輸入信箱')"
                :validate="emailValidator"
                name="email"
                v-model:value="email"/>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="passwordReseting">
        <div class="password-container">
          <div class="input-label">{{ $router.lang.get('輸入新密碼：') }}</div>
          <div class="email-input">
            <pang-input 
            :placeholder="$router.lang.get('密碼')" ref='password2' required
            v-model:value="password2" name="password"
            type="password" :validate="passwordValidator"
            @enter="nextInput($refs.password3)"/>
          </div>
        </div>
        <div class="password-container">
          <div class="input-label">{{ $router.lang.get('確認新密碼：') }}</div>
          <div class="email-input">
            <pang-input 
            :placeholder="$router.lang.get('密碼')" ref='password3' required
            v-model:value="password3" name="password"
            type="password" :validate="passwordValidator"
            @enter="changePassword"/>
          </div>
        </div>
        </template>
        <div v-else >
          <div class="email-code-hint">{{ $router.lang.get('已發送驗證碼到 {email} 信箱', {email: email}) }}</div>
          <div class="password-container">
            <div class="input-label">{{ $router.lang.get('驗證碼：') }}</div>
            <div class="email-input">
              <pang-sms-email
                ref="emailCode"
                :hint="$router.lang.get('驗證碼為 6 位數字')"
                v-model:value="emailCode"
                :email="email"
                :onBlur="codeValidator"
                :verifyType="4"
                :onEnter="submit"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="butt-container">
        <div>
          <pang-butt :text="$router.lang.get('取消')" @click="goback()" btype="account-cancel" :loading="loading"/>
        </div>
        <div>
          <pang-butt :text="$router.lang.get('確認')" @click="submit" btype="account-submit" :loading="loading"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { useScreenState } from '../../store';
import { PangTitle, PangTab, PangInput, PangButt, PangSmsInput, PangSmsEmail } from '../../components'
import validate from "../../utils/validate";
import request from '../../api/request'
import message from '../../utils/message'
import { pwHash } from '../../utils';


export default {
  name: "ForgetPassword",
  components: {
    PangTitle,
    PangTab,
    PangInput,
    PangButt,
    PangSmsInput,
    PangSmsEmail,
  },
  data() {
    return {
      screenState: useScreenState(),
      currentTab: 1,
      tabs: [
        this.$router.lang.get('查詢賬號'),
        this.$router.lang.get('查詢密碼'),
      ],
      currentTab2: 0,
      tabs2: [
        this.$router.lang.get('手機找回'),
        this.$router.lang.get('信箱找回'),
      ],
      areacode: '66',
      email: '',
      phone: '',
      code:'',
      value: '',
      username: '',
      loading: false,
      currentUser: null,
      passwordReseting: false,
      emailSending: false,
      password2: '',
      password3: '',
      emailCode: '',
      passwordValidator: validate.password,
      codeValidator: validate.code,
    }
  },
  computed: {
    isCollapse() {
      return this.screenState.screenWidth < 900;
    },
  },
  methods: {
    phoneValidator (str) {
      let res = validate.phone(str)
      if (res)
        return res
      if (this.currentUser && this.currentUser.areacode + this.currentUser.phone != str && this.currentUser.areacode + '0' + this.currentUser.phone != str) {
        return this.$router.lang.get('不是該賬號綁定的手機號')
      }
    },
    emailValidator (str) {
      let res = validate.email(str)
      if (res)
        return res
      if (this.currentUser && this.currentUser.email != str) {
        return this.$router.lang.get('不是該賬號綁定的信箱')
      }
    },
    async usernameValidator (str) {
        if (/^\d+$/.test(str))
            str = str.replace(/^0/, '')
      let res = validate.usernameLogin(str)
      if (res)
        return res
      else {
        this.currentUser = null
        res = await request.get('/users', { username: str })
        if (res.status == 200) {
          if (res.data.results.length == 0)
            return this.$router.lang.get('未查找到該賬號')
          let user = res.data.results[0]
          this.currentUser = user
          if (this.currentTab2 == 0 && !user.phone) {
            return this.$router.lang.get('該賬號沒有綁定手機號')
          }
          if (this.currentTab2 == 1 && !user.email) {
            return this.$router.lang.get('該賬號沒有綁定信箱')
          }
        }
      }
    },
    goback () {
      if (this.passwordReseting)
        this.passwordReseting = false
      else if (this.emailSending)
        this.emailSending = false
      else
        this.$router.back();
    },
    changePassword () {
      let val1 = this.$refs.password2.validateValue(this.password2)
      let val2 = this.$refs.password3.validateValue(this.password3)
      if (val1 && val2) {
        if (this.password2 != this.password3)
          message.showMessage(this, this.$router.lang.get('確認新密碼不一致'))
        else {
          let data = {
            verify_type: 4,
            user: this.currentUser.id,
            password: pwHash(this.password2),
          }
          if (this.currentTab2 == 0) {
            data.phone = this.phone.replace(/^0/, '')
            data.areacode = this.areacode
            data.verify_source = 1
            data.code = this.code
          }
          else {
            data.email = this.email
            data.verify_source = 2
            data.code = this.emailCode
          }
          this.loading = true
          let _this = this
          request.post('/verify/password', data).then(function (res) {
              if (res.status == 200) {
                _this.$router.replace('/account/login')
              }
              else {
                message.resMessage(res, _this)
              }
              _this.loading = false
          })
        }
      }
    },
    nextInput (next) {
      next.focus()
    },
    sendEmail () {
      let _this = this
      setTimeout(() => {
        _this.$refs.emailCode.getCode()
        _this.loading = false
      }, 500);
    },
    async submit () {
      if (this.passwordReseting)
        this.changePassword()
      else {
        this.loading = true
        let validated = true
        if (this.emailSending) {
          validated = !this.codeValidator(this.emailCode)
        }
        else {
          let val1 = await this.$refs.username.validateValue(this.username)
          let val2 = true
          if (this.currentTab2 == 0)
            val2 = await this.$refs.sms.validateValue()
          else
            val2 = await this.$refs.email.validateValue(this.email)
          validated = val1 && val2
        }
        if (validated) {
          if (this.currentTab2 == 1 && !this.emailSending) {
            this.emailSending = true
            this.sendEmail()
          }
          else {
            let data = {
              verify_type: 4
            }
            if (this.currentTab2 == 0) {
              data.phone = this.phone.replace(/^0/, '')
              data.areacode = this.areacode
              data.verify_source = 1
              data.code = this.code
            }
            else {
              data.email = this.email
              data.verify_source = 2
              data.code = this.emailCode
            }
            let _this = this
            request.post('/verify/check', data).then(function (res) {
                if (res.status == 200) {
                  _this.passwordReseting = true;
                }
                else {
                  message.resMessage(res, _this)
                }
                _this.loading = false
            })
          }
        }
      }
    },
  },
  watch: {
    currentTab (val) {
      if (val == 0)
        this.$router.replace('/account/forgetaccount')
    },
    currentTab2 (val) {
      if (val == 0) {
        this.email = this.value
        this.value = this.phone
      }
      else {
        this.phone = this.value
        this.value = this.email
      }
    },
  },
};
</script>

<style>

.forget-password-container .pang-tab > div {
    max-width: 170px;
    width: 31.27vw;
}

.tab2-container .pang-tab {
    display: block;
}

.tab2-container .pang-tab > div {
    width: 120px;
    height: 30px;
    border-radius: 14px;
    line-height: 30px;
    text-align: center;
    margin-right: 20px;
    font-size: 14px;
    margin-top: 22px;
    display: inline-block;
}

.tab2-container .pang-tab > .inactive {
    border: 1px solid #A3A3A3;
    color: #67696D;
}

.tab2-container .active {
    background-color: #C5A76C;
    color: #FFFFFF;
    border: none;
}

.email-code-hint {
  margin-bottom: 50px;
}

</style>

<style scoped>

.forget-password-container {
  width: 90vw;
  max-width: 824px;
  margin-left: auto;
  margin-right: auto;
  color: #999999;
}

.tab2-container {
  margin-top: 30px;
  margin-bottom: 70px;
}

.password-container {
  display: flex;
  line-height: 46px;
  margin-bottom: 33px;
}

.input-label {
  width: 100px;
}

.input-container {
  width: calc(90vw - 100px);
  max-width: 699px;
  line-height: 24px;
  display: flex;
}

select {
  font-size: 16px;
  font-weight: 300;
  color: #999999;
  border: 1px solid #c7c7c7;
  border-radius: 4px;
  background-color: #fff;
  padding: 0 10px;
  width: 120px;
  height: 46px;
}

select:focus {
  outline: none !important;
  border: 1px solid #c7c7c7;
}

.select-container {
  width: 140px;
}

.phone-input {
  max-width: 400px;
  width: calc(100% - 140px);
}

.email-input {
  width: calc(90vw - 100px);
  max-width: 699px;
}

.butt-container {
  display: flex;
}

.butt-container > div {
  max-width: 280px;
  width: calc(45vw - 20px);
  margin: 0 auto;
}

.butt-container > div:first-child {
  margin-right: 11px;
}

.butt-container > div:first-child > button {
  background-color: #C6C9CE;
}

.butt-container > div:last-child {
  margin-left: 12px;
}

.sms-container {
  width: 100%;
}
</style>